<section class="login-section">
    <div class="logo-section">
        <img class="logo" src="assets/images/kangologo.png">
    </div>
    <div class="email-section forgot-psw">
        <h3>Reset Password</h3>
        <p>Welcome to Kango Express! Please enter new password.</p>
        <p class="card-stat text-center text-success" *ngIf="!showdata">{{msg}}</p>
        <form [formGroup]="resetPwdForm" (ngSubmit)="onFormSubmit()" *ngIf="showdata">
            <div class="kg-form-data login-data">
                <div class="form-row">
                    <div class="form-group col-md-12 left-15 mt-0">
                        <input type="password" formControlName="password" class="form-control"
                            placeholder="New Password">
                        <span class="error"
                            *ngIf="resetPwdForm.get('password').touched && resetPwdForm.get('password').errors?.required">
                            Please enter new password
                        </span>
                        <span class="error"
                            *ngIf="resetPwdForm.get('password').touched && resetPwdForm.get('password').errors?.minlength">
                            Please enter valid password
                        </span>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12 left-15 mt-0">
                        <input type="password" formControlName="confirmPwd" class="form-control"
                            placeholder="Confirm New Password">
                        <span class="error"
                            *ngIf="resetPwdForm.get('confirmPwd').touched && resetPwdForm.get('confirmPwd').errors?.required">
                            Please enter confirm password
                        </span>
                        <span class="error"
                            *ngIf="resetPwdForm.get('confirmPwd').touched && resetPwdForm.get('confirmPwd').errors?.pwdsDontMatch">
                            Passwords must match
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" [disabled]="!resetPwdForm.valid" class="btn btn-info btn-block">Reset</button>
                </div>
            </div>
        </form>
    </div>

</section>